export default {
    accounts_export_logs_id: "Id",
    accounts_export_logs_account_id: "Account Id",
    accounts_export_logs_auth_id: "Auth Id",
    accounts_export_logs_created_on: "Created On",
    accounts_export_logs_error_message: "Error Message",
    accounts_export_logs_name: "Name",
    accounts_export_logs_output_url: "File",
    accounts_export_project_id: "Project Id",
    accounts_export_status: "Status",
    accounts_export_status_updated_on: "Updated On",
    accounts_export_type: "Type",
    accounts_export_processes_records: "Processed Records",
    accounts_export_total: "Total",
    accounts_export_report: "Report",
    accounts_export_status_completed: "Completed",
    accounts_export_status_pending: "Pending",
    accounts_export_status_processing: "Processing",
    accounts_export_status_in_progress: "In Progress",
    accounts_export_status_failed: "Failed",
    accounts_export_status_error: "Error",
    accounts_export_status_cancelled: "Cancelled",
}